export const GET_PRODUCTS_LIST = "GET_PRODUCTS_LIST";
export const GET_PRODUCT = "GET_PRODUCT";
export const GET_KNOWLEDGE_CENTER = "GET_KNOWLEDGE_CENTER";
export const ADD_TO_CART = "ADD_TO_CART";
export const CHECKOUT_ORDER = "CHECKOUT_ORDER";
export const GET_SITES_LIST = "GET_SITES_LIST";